import React from "react";
import "../../css/style.css";
class HeaderTopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.error = null;
    this.loading = null;
  }

  render() {
    this.error = this.props.error;
    this.loading = this.props.loading;

    return (
      <>
        <div className="text-right container merchant-logo-container">
          {" "}
          {this.props?.merchantLogoSrc ? (
            <div>
              <img
                src={this.props?.merchantLogoSrc}
                alt="logo"
                className="merchant-logo"
              />
            </div>
          ) : null}{" "}
        </div>
      </>
    );
  }
}

export default HeaderTopBar;
